import LookerEmbedTab from 'components/LookerEmbedTab'
import TabPane from 'components/Tabs/TabPane'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/436'

// `mountOnEnter` matters here: TabsContainer renders every tab's content, and
// `Tab.Container transition={false}` keeps inactive panes mounted — so without
// it LookerEmbedTab mounted immediately and fetched
// `<merchant>/looker/embed_url` for a tab the user may never open. Deferring
// the mount defers that request to first entry.
const PointActivityByLifecycleStageTab: React.FC = () => (
  <TabPane state="point_activity_by_lifecycle_stage" mountOnEnter>
    <LookerEmbedTab
      path={DASHBOARD_PATH}
      translationKey="points.point_activity_by_lifecycle_stage"
    />
  </TabPane>
)

export default PointActivityByLifecycleStageTab
